import React, { useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader, Button } from "reactstrap";
import "./style.css";

const Reset = ({ open, handleClose, handleMail, emailSending }) => {
  const [email, setEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const handleChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    if (!emailRegex.test(value)) {
      setErrorMessage("Please enter a valid email address.");
    } else {
      setErrorMessage("");
    }
  };

  return (
    <Modal className="modal-2fa" isOpen={open} toggle={handleClose} centered>
      <ModalHeader toggle={handleClose}>Recovery Code</ModalHeader>

      <ModalBody>
        <div className="text-center mb-4">
          <p className="font-weight-bold mb-2">
            Remove Two Factor Authentication
          </p>
          <p className="text-muted small">
            To remove two-factor authentication from your account, we will send
            you an email with a verification link.
          </p>
        </div>

        <div className="mb-4">
          <h6 className="font-weight-bold text-center mb-3">
            Enter Your Email:
          </h6>

          <input
            type="email"
            placeholder="Enter your email"
            className="form-control custom-inputbox"
            value={email}
            onChange={handleChange}
          />
          {errorMessage && <p className="text-danger mt-2 text-center">{errorMessage}</p>}
        </div>
      </ModalBody>

      <ModalFooter className="d-flex justify-content-center">
        <Button color="secondary" onClick={handleClose}>
          Cancel
        </Button>

        <Button
          color="primary"
          onClick={() => handleMail(email)}
          disabled={!email || emailSending}>
          Reset
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default Reset;
